export const createLogBiHandler = bi => (...args) => {
  bi.log(...args);
};
